import React from 'react';
import PropTypes from 'prop-types';

import { InteractivePropType } from 'propTypes/common';

// eslint-disable-next-line import/no-cycle
import Exhibits from './interactives/Exhibits';
import DoubleImages from './interactives/DoubleImages';
import TestCorrect from './interactives/TestCorrect';
import TestSummary from './interactives/TestSummary';
import TestTree from './interactives/TestTree';
import UpturnCards from './interactives/UpturnCards';
import Divination from './interactives/Divination';

const StyledContentInteractive = ({ interactive, result }) => {
	switch (interactive.type) {
		case 'exposition':
			return <Exhibits {...{ interactive }} />;
		case 'doubleImages':
			return <DoubleImages {...{ interactive }} />;
		case 'testCorrect':
			return (
				<TestCorrect
					{...{
						interactive,
						initialScore: result?.score,
						initialDifficulty: result?.difficulty
					}}
				/>
			);
		case 'testSummary':
			return <TestSummary {...{ interactive, initialScore: result?.score }} />;
		case 'testTree':
			return <TestTree {...{ interactive, initialIndex: result?.index }} />;
		case 'upturnCards':
			return <UpturnCards {...{ interactive }} />;
		case 'divination':
			return <Divination {...{ interactive }} />;
		default:
			return null;
	}
};

StyledContentInteractive.propTypes = {
	interactive: InteractivePropType,
	result: PropTypes.shape({
		score: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		difficulty: PropTypes.string,
		index: PropTypes.number
	})
};

export default StyledContentInteractive;
